import * as React from 'react'
import BaseIcon from 'react-icon-base'
import { IIconProps } from './interface'

const LeaderBoardActiveIcon = (props: IIconProps) => (
  <BaseIcon width="16" height="16" viewBox="0 0 16 16" {...props}>
    <path
      fill="#2ED8A7"
      fillRule="evenodd"
      d="M15.531 1.155h-2.053c.007-.228.012-.456.012-.686A.469.469 0 0 0 13.02 0H2.98a.469.469 0 0 0-.47.469c0 .23.005.458.012.686H.469A.469.469 0 0 0 0 1.624c0 2.1.549 4.081 1.546 5.58.985 1.48 2.297 2.33 3.715 2.412.321.35.661.635 1.015.853v2.083H5.49c-.951 0-1.724.774-1.724 1.724v.786h-.034a.469.469 0 0 0 0 .938h8.536a.469.469 0 1 0 0-.938h-.034v-.786c0-.95-.773-1.724-1.724-1.724h-.786V10.47a4.813 4.813 0 0 0 1.015-.853c1.418-.082 2.73-.932 3.715-2.413C15.451 5.705 16 3.723 16 1.623a.469.469 0 0 0-.469-.468zM2.326 6.685C1.504 5.448 1.021 3.832.947 2.091h1.627c.17 2.14.672 4.117 1.457 5.687.125.25.255.486.39.709-.779-.295-1.5-.91-2.095-1.804zm11.348 0c-.595.893-1.316 1.508-2.096 1.803.136-.223.266-.459.391-.709.785-1.57 1.287-3.547 1.457-5.687h1.627c-.074 1.74-.557 3.357-1.38 4.592z"
    />
  </BaseIcon>
)

export default LeaderBoardActiveIcon
